module.exports = __webpack_public_path__ + "static/bind.17d622dc.png";